import { ODataError } from "@odata/Data.types";
import { parseResponse } from "@odata/ODataParser";
import customFetch, { getDefaultPostParams } from "@utils/customFetch";
import { logger } from "@utils/log";

import { REST_API_URL } from "../../../constants";
import { Status } from "../../../enums";
import { getAlertFromError } from "../../../views/formView/Form.utils";
import { FormStorage } from "../../../views/formView/FormStorage";

const RESEND_INVITATION_INFO_URL = `${REST_API_URL}/invitation/UpsertInvitation`;

export async function resendUserInvitation(storage: FormStorage<any>, userId: number): Promise<void> {
    try {
        const res = await customFetch(RESEND_INVITATION_INFO_URL, {
            ...getDefaultPostParams(),
            body: JSON.stringify({
                TenantUserId: userId
            })
        });

        if (res.ok) {
            const alert = {
                status: Status.Success,
                title: storage.t("Common:Validation.SuccessTitle"),
                subTitle: storage.t("Users:ResendInvitationSuccess")
            };
            storage.setFormAlert(alert);
            storage.refresh();
        } else {
            const error: ODataError = await parseResponse(res);
            storage.setFormAlert(getAlertFromError(error));
        }
    } catch (error) {
        logger.error("resendUserInvitation failed", error);
        storage.setFormAlert({
            status: Status.Error,
            title: storage.t("Common:Errors.ErrorHappened"),
            detailData: error
        });
    }
}